// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__4bMu0","title":"InfoRow_title__x5xyJ"};